import { render, staticRenderFns } from "./OrderFormDialog.vue?vue&type=template&id=d524a0ce&scoped=true"
import script from "./OrderFormDialog.vue?vue&type=script&lang=js"
export * from "./OrderFormDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderFormDialog.vue?vue&type=style&index=0&id=d524a0ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d524a0ce",
  null
  
)

export default component.exports